import Hotjar from '@hotjar/browser'

const siteId = process.env.REACT_APP_HOTJAR_SITE_ID || ''
const hotjarVersion = process.env.REACT_APP_HOTJAR_VERSION || ''

Hotjar.init(Number(siteId), Number(hotjarVersion))
